import { IPageName } from '../../common/types/apiSchema';
import { PathMap } from './paths';

/**
 * Localised URLs for Slovakia
 */
export const SkPaths: PathMap = {
  [IPageName.collections]: ['/:filterslug/filter'],
  [IPageName.instantAccess]: ['/okamzity-pristup/:affilate'],
};
